<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goToManageReseller()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Manage Reseller
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="row d-felx justify-content-center">
                <div class="col-sm-12 col-md-5 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Reseller Name</mat-label>
                        <input matInput maxlength="50" formControlName="resellerName" placeholder="Enter Reseller Name"
                            required class="col-12" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-5 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Reseller Code</mat-label>
                        <input matInput formControlName="resellerCode" placeholder="Enter Reseller Promo Code" required
                            [readonly]="paramsid === 0 ? false : true" maxlength="10" class="col-12" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 col-md-5 mt-4" style="margin-left: 6rem;">
                    <mat-checkbox style="transform: scale(1.3);" color="primary" class="prepaid-checkbox"
                        formControlName="IsAddOrUpdateInReach">
                        {{ addCondition == true ? 'Add Reseller details in Prepaid portal' : 'Update Reseller details in Prepaid portal' }}
                    </mat-checkbox>
                </div>
            </div>


            <div class="d-flex justify-content-center button-style">
                <button class="btn btn-secondary mb-3 mt-5" (click)="onsubmit()" matButton>{{paramsid ===0
                    ?'Save': 'Update'}}</button>
            </div>
        </form>
    </div>
</div>